export default __webpack_public_path__ + "static/media/logo.9a324b6d.png";